import type { ContactForm } from '@/features/publicsite/types/ContactForm';
import type { SearchHit } from '@/features/publicsite/types/SearchHit';
import { apiGet, apiPost } from '@/services/api';

export const publicSearchApi = {
  search: (query: string, limit = 50) =>
    apiGet<{ items: SearchHit[] }>(
      `/api/v1/public/search?q=${encodeURIComponent(query)}&limit=${limit}`,
    ),
  sendContact: (form: ContactForm) => apiPost('/api/v1/public/contact', form),
};
